import React, { createRef } from "react";
import moment from "moment";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  Skeleton,
  Checkbox,
} from "antd";
import { getUser } from "../../../utils/helpers";
import {
  getInstruments,
  fetchActiveRA,
  fetchTestCategory,
  fetchInstrumentMethods,
} from "../../../actions/chemistry";
import PendingTableRow from "./Components/Table/PendingTableRow";

import "./ChemBioPending.css";
import PendingTableHeader from "./Components/Table/PendingTableHeader";
import PendingTable from "./Components/Table/PendingTable";
import PendingFilterSection from "./Components/PendingFilterSection";
import PendingLegendSection from "./Components/PendingLegendSection";
import { ChemBioPendingContext } from "./ChemBioPendingContext";

class ChemBioPending extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pendingTableData: [],
      pendingFlag: false,
      queryPending: "",
      flag: "pending",
      selectedDate: moment(Date.now()).format("MM/DD/YY"),
      loading: false,
      instrumentLoading: true,
      categoryLoading: true,
      methodLoading: true,
      apiController: null,
      technicianEmail: "",
      category: "",
      selectedInstrumentId: "",
      selectedInstrumentMethod: "",
      chemFilterList: [{ value: "", label: "All Categories" }],
      instrumentList: [
        { value: "", label: "All Instruments" },
      ],
      instrumentMethodList: [
        { value: "", label: "All Instrument Methods" },
      ],
      chemColumns: [
        {
          name: "Test", param: "Test", permission: "no-permission",
        },
        { name: "Instrument", param: "instrument_name", permission: "no-permission" },
        {
          name: "Pending", param: "id", sample_status: "pending", isGenistaCol: true, permission: "no-permission",
        },
        {
          name: "Extracted", param: "id", sample_status: "extract", isGenistaCol: true, enableGenerate: true, permission: "no-permission",
        },
        {
          name: "Loaded", param: "id", sample_status: "load", isGenistaCol: true, enableGenerate: true, permission: "no-permission",
        },
        {
          name: "Analyzed", param: "id", sample_status: "analyze", isGenistaCol: true, permission: "change_results",
        },
      ],
      bioChemColumns: [
        { name: "Test", param: "Test", permission: "no-permission" },
        {
          name: "GenistaID", param: "id", isGenistaCol: true, permission: "no-permission",
        },
      ],
      modalMap: new Map(), // { instrument : { gid: { pending: [ { testName, id: }, ...], extract: [...] } } }
      raList: [
        { value: "", label: "All Assigned To" },
      ],
      raLoading: true,
      // disableAllPopup: false,
      sampleStatusMap: new Map(),
      mrlInstruments: [],
      enableExtractedColumn: false,
      selectedGenerate: new Map(),
      instrumentBrandsMap: {},
    };
    this.isUnmounted = false;
    this.sequenceCompRef = createRef();
    this.instrumentMap = new Map();
    this.mrlTestSet = new Set();
  }

  componentDidMount() {
    this.fetchAllFilterValues();
    this.generatePendingQueue();
  }

  componentWillUnmount() {
    this.isUnmounted = true; // Set the flag to indicate unmounting
    this.abortPrevApiCall(null);
  }

  setMethodList() {
    const { chemDropdown } = this.props;
    // Only make the API call if this is a Chemistry tab
    if (chemDropdown) {
      this.setState({ categoryLoading: true }, async () => {
        const {
          success, instrument_methods, instrument_brand_map, message,
        } = await fetchInstrumentMethods();
        let instrumentBrandsMap = {};
        const newMethodList = [{ value: "", label: "All Instrument Methods" }];
        if (success) {
          instrument_methods.forEach((item) => newMethodList.push({ value: item }));
          instrumentBrandsMap = instrument_brand_map;
        } else {
          toast.error(message);
        }
        this.setState({
          instrumentMethodList: newMethodList,
          instrumentBrandsMap,
          methodLoading: false,
        });
      });
    }
  }

  async setMrlTestSet() {
    const { chemDropdown } = this.props;
    // Only make the API call if this is a Chemistry tab
    if (chemDropdown) {
      const { success, results, message } = await fetchTestCategory();
      if (success) {
        results.forEach((item) => {
          if (item.id === 27) {
            item.tests.forEach((test) => {
              this.mrlTestSet.add(test.internal_name);
            });
          }
        });
      } else {
        toast.error(message);
      }
    }
  }

  /**
   * Get and set instruments data
   */
  setInstrumentList = async () => {
    const { chemDropdown } = this.props;
    // Only make the API call if this is a Chemistry tab
    if (chemDropdown) {
      this.setState({ instrumentLoading: true }, async () => {
        const { success, result, message } = await getInstruments();
        let instrumentOptions = [];
        let mrlInstruments = [];
        if (success) {
          const sortedOptions = [
            { value: "Meter", label: "Meter" },
            ...result.map((item) => ({ value: item.id, label: item.instrument_name })),
          ].sort((a, b) => a.label.localeCompare(b.label));
          instrumentOptions = [
            { value: "", label: "All Instruments" },
            ...sortedOptions,
          ];
          mrlInstruments = result.filter((item) => item.id === 4 || item.id === 5);
          result.forEach((item) => this.instrumentMap.set(item.id, item));
        } else {
          toast.error(message);
        }
        this.setState({ instrumentList: instrumentOptions, mrlInstruments, instrumentLoading: false });
      });
    }
  };

  /**
   * Get and set RA data
   */
  setRaList = async () => {
    const { chemDropdown } = this.props;
    // Only make the API call if this is a Chemistry tab
    if (chemDropdown) {
      const { success, results, message } = await fetchActiveRA();
      let raList = [];
      if (success) {
        const sortedOptions = [ // Only add chemistry technicians. Only for Chemistry category, the logic item.category === item.technician_team will be true
          ...results.reduce((acc, item) => {
            if (item.category.toLowerCase() === "chemistry" || item.category === item.technician_team) {
              acc.push({ value: item.email, label: `${item.first_name} ${item.last_name}`.trim() });
            }
            return acc;
          }, []),
        ].sort((a, b) => a.label.localeCompare(b.label));
        raList = [
          { value: "", label: "All Assigned To" },
          ...sortedOptions,
        ];
      } else {
        toast.error(message);
      }
      this.setState({ raList, raLoading: false });
    }
  };

  fetchAllFilterValues = async () => {
    this.setMrlTestSet();
    this.setInstrumentList();
    this.setRaList();
    this.setMethodList();
  }

  /**
   * Use the AbortController to cancel the last producttemplates/ call if the last call was still in progress.
   * @param {*} controller
   */
  abortPrevApiCall = (controller) => {
    const { apiController } = this.state;
    if (apiController) {
      apiController.abort();
    }
    this.setState({ apiController: controller });
  };

  /**
   * Create a map to get a test list for the same genista id with the same instrument and same status
   */
  createInstrumentGidMap = (list) => {
    const { chemDropdown } = this.props;
    const modalMap = new Map();
    const sampleStatusMap = new Map();
    const selectedGenerate = new Map();
    if (!list || !chemDropdown) return { modalMap, sampleStatusMap, selectedGenerate };

    /** Initialize the selectedGenerate map */
    selectedGenerate.set("load", new Map());
    selectedGenerate.set("extract", new Map());
    selectedGenerate.set("extractCount", 0);
    selectedGenerate.set("loadCount", 0);

    /** Loop through each genista id to update the map values */
    list.forEach((item) => {
      const {
        Test, id, instrument_name, generate_load_excel,
      } = item;
      // Setup the highest level map: { instrument: }
      if (!modalMap.has(instrument_name)) modalMap.set(instrument_name, new Map());
      if (!sampleStatusMap.has(Test)) sampleStatusMap.set(Test, new Map());
      id.forEach((testItem) => {
        const { genista_id, sample_status } = testItem;
        // Compute the total generate_load_excel test for both extract and load
        if (generate_load_excel && selectedGenerate.has(`${sample_status}Count`)) {
          selectedGenerate.set(`${sample_status}Count`, selectedGenerate.get(`${sample_status}Count`) + 1);
        }

        /** Update the samlpeStatusMap and modalMap */
        if (!sampleStatusMap.get(Test).has(sample_status)) sampleStatusMap.get(Test).set(sample_status, []);
        sampleStatusMap.get(Test).get(sample_status).push(testItem);
        // Setup the second level map: { instrument: gid: {} }
        if (!modalMap.get(instrument_name).has(genista_id)) modalMap.get(instrument_name).set(genista_id, new Map());
        // Setup the third level map: { instrument: gid: { sample_status: [] } }
        if (!modalMap.get(instrument_name).get(genista_id).has(sample_status)) modalMap.get(instrument_name).get(genista_id).set(sample_status, []);

        // Push an object { test, test_in_sample_id } into the (instrument -> gid -> sample_status) array
        modalMap.get(instrument_name).get(genista_id).get(sample_status).push({ ...testItem, test: Test });
      });
    });
    return { modalMap, sampleStatusMap, selectedGenerate };
  }

  generatePendingQueue = async (q, dateChange, loading = true) => new Promise((resolve) => {
    const { chemFilterList } = this.state;
    this.setState({ loading, categoryLoading: chemFilterList.length === 1 }, async () => {
      const {
        selectedDate,
        category,
        queryPending,
        selectedInstrumentId,
        technicianEmail,
        selectedInstrumentMethod,
      } = this.state;
      const { getPendingResults } = this.props;
      let date;
      if (dateChange) {
        date = dateChange;
      } else {
        date = selectedDate;
      }
      if (!!q && q.endsWith(".com")) {
        q = "";
      }
      const controller = new AbortController();
      this.abortPrevApiCall(controller);
      const payload = {
        input: q || queryPending,
        date,
        category,
        instrument_id: selectedInstrumentId,
        technician: technicianEmail,
        instrument_method: selectedInstrumentMethod,
        role_id: getUser()?.role,
      };
      const results = await getPendingResults(payload, controller.signal);
      if (this.isUnmounted) {
        return;
      }
      const table_data = results;
      const {
        modalMap, sampleStatusMap, selectedGenerate,
      } = this.createInstrumentGidMap(results?.List);
      if (results && results.success) {
        const sortedChemCategoryList = results?.distinct_test_categories?.sort((a, b) => a.localeCompare(b)).map((item) => ({ value: item, label: item }));
        const chemCategoryList = [{ value: "", label: "All Categories" }, ...(sortedChemCategoryList || [])];
        this.setState({
          pendingTableData: table_data,
          modalMap,
          sampleStatusMap,
          pendingFlag: true,
          flag: "pending",
          loading: false,
          selectedGenerate,
          chemFilterList: chemCategoryList,
          categoryLoading: false,
        });
      } else if (results.canceled) {
        this.setState({
          pendingTableData: [],
          modalMap,
          pendingFlag: false,
          flag: "pending",
        });
      } else if (results.message === "Something went wrong.") {
        this.setState({
          pendingTableData: [],
          modalMap,
          pendingFlag: false,
          flag: "pending",
          loading: false,
          categoryLoading: false,
        });
        toast.error("Something went wrong");
      } else {
        this.setState({ pendingTableData: [], modalMap, loading: false, categoryLoading: false });
        toast.error("Something went wrong");
      }
      resolve(true);
    });
  });

  handleDate = (e) => {
    if (!e) {
      return;
    }
    let date = moment(e.$d).format("MM/DD/YY");
    const input = "";
    if (date === "Invalid date") {
      date = "";
    }
    this.setState({ selectedDate: date }, () => { this.generatePendingQueue(input, date); });
  };

  generateChemQueue = async (target_date, q) => {
    this.setState({ loading: true }, async () => {
      const { flag } = this.state;
      const { searchPendingResult } = this.props;
      if (flag === "pending") {
        const elem = document.getElementById("search");
        elem.value = null;
      }
      const queryQueue = q;
      const controller = new AbortController();
      this.abortPrevApiCall(controller);
      const results = await searchPendingResult(target_date, queryQueue, controller.signal);
      if (results.message === "Something went wrong.") {
        toast.error("No tests data!");
        this.setState({
          flag: "queue",
          pendingTableData: [],
          pendingFlag: false,
          queryPending: "",
          loading: false,
        });
      }

      if (results && results.success) {
        this.setState({
          flag: "queue",
          pendingTableData: [],
          pendingFlag: false,
          queryPending: "",
          loading: false,
        });
      }
    });
  }

  onSearch = (e) => {
    let q;
    const {
      flag,
    } = this.state;
    if (flag === "pending") {
      q = e.target.value;
      this.setState({ queryPending: q }, () => {
        this.generatePendingQueue(q);
      });
    }
  };

  addTableRowPending = (data, i) => {
    const { chemDropdown, helperFn } = this.props;
    const {
      modalMap, sampleStatusMap, mrlInstruments, enableExtractedColumn, selectedGenerate,
    } = this.state;
    return (
      <tr key={i}>
        <PendingTableRow
          data={data}
          chemDropdown={chemDropdown}
          getTargetColumns={this.getTargetColumns}
          getTestList={this.getTestList}
          markTestRunOnInstrument={helperFn?.markTestRunOnInstrument}
          updateTestResult={helperFn?.updateTestResult}
          generatePendingQueue={this.generatePendingQueue}
          modalMap={modalMap}
          sampleStatusMap={sampleStatusMap}
          mrlInstruments={mrlInstruments}
          enableExtractedColumn={enableExtractedColumn}
          handleExtractedCheckboxOnChange={this.handleExtractedCheckboxOnChange}
          selectedGenerate={selectedGenerate}
        />
      </tr>
    );
  }

  addTableSkeleton = (i) => {
    const targetCols = this.getTargetColumns();
    return (
      <tr key={i}>
        {targetCols.map((_, j) => (<td key={j} className="PendingTable__Skeleton__SampleTd"><Skeleton.Input className="PendingTable__Skeleton__Sample" active /></td>))}
      </tr>
    );
  }

  /**
   * Handle the filter dropdown on select change
   * @param {*} text
   * @param {*} technician_name
   */
  onChemFilterSelect = (text) => {
    this.setState({
      category: text,
      loading: true,
    }, () => this.generatePendingQueue());
  }

  onRaFilterSelect = (text) => {
    this.setState({
      technicianEmail: text,
      loading: true,
    }, async () => {
      this.generatePendingQueue();
    });
  }

  /**
   * Handle the Instrument filter dropdown on select change
   */
  onInstrumentSelect = (instrumentId = "") => {
    this.setState({
      loading: true,
      selectedInstrumentId: instrumentId,
    }, () => {
      this.generatePendingQueue();
    });
  }

  /**
   * Handle the Instrument filter dropdown on select change
   */
  onInstrumentMethodSelect = (selectedInstrumentMethod = "") => {
    this.setState({
      loading: true,
      selectedInstrumentMethod,
    }, () => {
      this.generatePendingQueue();
    });
  }

  getTargetColumns = () => {
    const { chemDropdown } = this.props;
    const { chemColumns, bioChemColumns } = this.state;
    const targetCols = chemDropdown ? chemColumns : bioChemColumns;
    const user = getUser();
    const authorizedColumns = targetCols.reduce((acc, item) => {
      const { permission } = item;
      if (permission === "no-permission" || user.permissionMap[permission]) {
        acc.push(item);
      }
      return acc;
    }, []);
    return authorizedColumns;
  }

  handleExtractedColumnSelectAll = (e, targetStatus) => {
    const checked = e.target.checked;
    const { pendingTableData, selectedGenerate } = this.state;
    const targetMap = selectedGenerate.get(targetStatus);
    if (!checked) {
      selectedGenerate.set(targetStatus, new Map());
      this.setState({ selectedGenerate: new Map(selectedGenerate) });
      return;
    }
    pendingTableData.List.forEach((item) => {
      if (item.generate_load_excel) {
        item.id.forEach((test) => {
          const { test_in_sample_id, sample_status } = test;
          if (sample_status === targetStatus) {
            targetMap.set(test_in_sample_id, test);
          }
        });
      }
    });
    this.setState({ selectedGenerate: new Map(selectedGenerate) });
  }

  PendingTableHeader = () => {
    const {
      loading, enableExtractedColumn, selectedGenerate,
    } = this.state;
    const targetCols = this.getTargetColumns();
    return targetCols.map((item, i) => (
      <td
        className={item.name.toLowerCase().includes("genista") ? "PendingTableGenistaCol" : ""}
        key={i}
      >
        {enableExtractedColumn && item.enableGenerate
        && (
        <Checkbox
          className="PendingTable__SelectAll"
          disabled={loading || selectedGenerate.get(`${item.sample_status}Count`) === 0}
          onChange={(e) => this.handleExtractedColumnSelectAll(e, item.sample_status)}
          checked={selectedGenerate.get(item.sample_status).size > 0 && selectedGenerate.get(`${item.sample_status}Count`) === selectedGenerate.get(item.sample_status).size}
        />
        )}
        {" "}
        {item.name}
      </td>
    ));
  }

  enableExtractedColumnSelection = (active) => {
    const { selectedGenerate } = this.state;
    if (!active) {
      ["extract", "load"].forEach((key) => selectedGenerate.set(key, new Map()));
      this.setState({ selectedGenerate: new Map(selectedGenerate) });
    }
    this.setState({ enableExtractedColumn: active });
  }

  handleExtractedCheckboxOnChange = (e, item, batchUpdate = false) => {
    const { selectedGenerate } = this.state;
    const { test_in_sample_id } = item;
    const sample_status = batchUpdate ? item[0].sample_status : item.sample_status;
    const checked = e.target.checked;
    const prevExtractChecked = selectedGenerate.get("extract").size;
    const prevLoadChecked = selectedGenerate.get("load").size;
    const extractTotal = selectedGenerate.get("extractCount");
    const loadTotal = selectedGenerate.get("loadCount");
    if (!batchUpdate) {
      if (checked) {
        selectedGenerate.get(sample_status).set(test_in_sample_id, item);
      } else {
        selectedGenerate.get(sample_status).delete(test_in_sample_id);
      }
    } else { // this handle the Select All checkbox within the cell
      item.forEach((test) => {
        if (checked) {
          selectedGenerate.get(test.sample_status).set(test.test_in_sample_id, test);
        } else {
          selectedGenerate.get(test.sample_status).delete(test.test_in_sample_id);
        }
      });
    }
    const curExtractChecked = selectedGenerate.get("extract").size;
    const curLoadChecked = selectedGenerate.get("load").size;

    if ( // update the state when the select all checkbox value needs to be updated
      (curExtractChecked === extractTotal && sample_status === "extract")
      || (curLoadChecked === loadTotal && sample_status === "load")
      || (prevExtractChecked === extractTotal && sample_status === "extract")
      || (prevLoadChecked === loadTotal && sample_status === "load")
    ) {
      this.setState({ selectedGenerate: new Map(selectedGenerate) });
    } else if (this.sequenceCompRef.current) { // update the Generate Sequence component state only
      this.sequenceCompRef.current.updateSelectedMap(new Map(selectedGenerate));
    }
  };

  render() {
    const {
      flag,
      pendingTableData,
      selectedDate,
      pendingFlag,
      loading,
      chemFilterList,
      instrumentList,
      instrumentLoading,
      raList,
      raLoading,
      category,
      selectedInstrumentId,
      technicianEmail,
      enableExtractedColumn,
      selectedGenerate,
      chemColumns,
      bioChemColumns,
      modalMap,
      sampleStatusMap,
      mrlInstruments,
      categoryLoading,
      selectedInstrumentMethod,
      instrumentMethodList,
      methodLoading,
      instrumentBrandsMap,
    } = this.state;
    const {
      showSearch,
      chemDropdown,
      helperFn,
    } = this.props;

    const contextValue = {
      flag,
      pendingTableData,
      selectedDate,
      pendingFlag,
      loading,
      chemFilterList,
      instrumentList,
      instrumentLoading,
      raList,
      raLoading,
      category,
      selectedInstrumentId,
      technicianEmail,
      enableExtractedColumn,
      selectedGenerate,
      chemColumns,
      bioChemColumns,
      modalMap,
      sampleStatusMap,
      mrlInstruments,
      showSearch,
      chemDropdown,
      helperFn,
      categoryLoading,
      selectedInstrumentMethod,
      instrumentMethodList,
      methodLoading,
      instrumentMap: this.instrumentMap,
      instrumentBrandsMap,
      mrlTestSet: this.mrlTestSet,

      // Filter section
      onSearch: this.onSearch,
      handleDate: this.handleDate,
      onChemFilterSelect: this.onChemFilterSelect,
      onInstrumentSelect: this.onInstrumentSelect,
      onRaFilterSelect: this.onRaFilterSelect,
      onInstrumentMethodSelect: this.onInstrumentMethodSelect,
      // Legend section
      sequenceCompRef: this.sequenceCompRef,
      enableExtractedColumnSelection: this.enableExtractedColumnSelection,
      // Pending Table
      handleExtractedColumnSelectAll: this.handleExtractedColumnSelectAll,
      getTargetColumns: this.getTargetColumns,
      getTestList: this.getTestList,
      generatePendingQueue: this.generatePendingQueue,
      handleExtractedCheckboxOnChange: this.handleExtractedCheckboxOnChange,
    };

    return (
      <div className="PendingTableContainer">
        <ChemBioPendingContext.Provider value={contextValue}>
          <PendingFilterSection />
          <PendingLegendSection />
          {!loading && flag === "pending" && (<PendingTable />)}
          {loading && (
          <Table bordered className="table">
            <PendingTableHeader />
            <tbody>
              {[...Array(8)].map((_, index) => this.addTableSkeleton(index + 1))}
            </tbody>
          </Table>
          )}
        </ChemBioPendingContext.Provider>
      </div>
    );
  }
}

export default ChemBioPending;
